import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bot } from 'lucide-react';
import { AI_TOOLS } from '../../constants/aiTools';
import ToolCard from '../../components/AiAssistant/ToolCard';

const AiAssistantDashboard = () => {
  const navigate = useNavigate();

  const handleCreate = (tool) => {
    navigate(`/ai-assistant/${tool.id}`);
  };

  return (
    <div style={{ padding: '1.5rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '0.5rem',
        flexWrap: 'wrap',
        gap: '1rem',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{
            width: '42px', height: '42px', borderRadius: '10px',
            background: 'var(--etpos-bg, #f0fdf4)', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}>
            <Bot size={24} color="#16a34a" />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800, color: 'var(--etpos-text, #111827)' }}>
              AI Assistant
            </h1>
            <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--etpos-text-muted, #6b7280)' }}>
              Choose a tool to generate content
            </p>
          </div>
        </div>

        <button
          onClick={() => navigate('/ai-assistant/history')}
          style={{
            background: 'var(--etpos-bg, #f0fdf4)',
            color: '#16a34a',
            border: '1px solid #bbf7d0',
            borderRadius: '7px',
            padding: '0.5rem 1.25rem',
            fontSize: '0.875rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--etpos-card, #dcfce7)'}
          onMouseLeave={e => e.currentTarget.style.background = 'var(--etpos-bg, #f0fdf4)'}
        >
          View History
        </button>
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '1.25rem 0' }} />

      {/* Tool Cards Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '1.25rem',
      }}>
        {AI_TOOLS.map((tool) => (
          <ToolCard key={tool.id} tool={tool} onCreateClick={handleCreate} />
        ))}
      </div>
    </div>
  );
};

export default AiAssistantDashboard;
